<mat-form-field style="border: 1px solid #EBEBEB;;border-radius: 8px;width: -webkit-fill-available;">
    <input 
    matInput
    type="input"
    [placeholder]="placeholder"
    (keyup)="onSearch($event)"
    />
    <mat-icon matPrefix>search</mat-icon>
</mat-form-field>